enum GenAIActionType {
  ImageToImageMasking,
  UpscaleImage, // Upscale
  ReplaceBackground,
  RemoveBackground, // Remove BG
  SketchToImage,
  TextToImage,
  ChatCompletion,
  GetEmbeddings,
  AudioTranscription,
  TextToSpeech,
  Outpainting, // Outpaint
  Inpaint, // Inpaing
  PromptToImage,
  ImageAnalysis,
  PromptToImageWithReferenceImages,
  ExtractTextLayers,
  ProxyResponseApi,
  EditByPrompt,
  ResourceSelection,
  AnswerGeneration,
  BoundingBoxDetection,
  ProductShot,
}

/**
 * Product type for product shot generation
 */
enum ProductShotType {
  Product = 0,
  Vehicle = 1,
}

export {GenAIActionType, ProductShotType};
